import HeroSection from './components/HeroSection';
import CoreValueSection from './components/CoreValueSection';
import CategorySection from './components/CategorySection';
import FeaturedArticlesSection from './components/FeaturedArticlesSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import HomeJsonLd from './components/HomeJsonLd';

export default function Home() {
  return (
    <>
      <HomeJsonLd />
      <HeroSection />
      <CoreValueSection />
      <CategorySection />
      <FeaturedArticlesSection />
      <FaqSection />
      <CtaSection />
    </>
  );
}